import { Dialog, Typography, DialogTitle, DialogContent, Box, CircularProgress } from "@mui/material";
import { useState, createContext } from "react";
import { ReactComponent as ExtraCardBackground } from "../assets/extraordinary-card-splash.svg"
import Logo from "../assets/logos/ExtraordinaryBlack.png"
import { extraordinaryColors } from "../utils/theme";

interface ICheckoutLoadingContext {
    setIsLoading: (isLoading: boolean) => void
}

const CheckoutLoadingContext = createContext<ICheckoutLoadingContext>({setIsLoading: () => {}});

const CheckoutLoadingProvider = ({ children }: { children: React.ReactNode }) => {
    const [isLoading, setIsLoading] = useState(false);

    return (
        <CheckoutLoadingContext.Provider value={{setIsLoading}}>
            <Dialog 
                open={isLoading} 
                onClose={() => setIsLoading(false)} 
                fullScreen
            >
                <Box
                    sx={{
                        background: extraordinaryColors.yellow.light,
                        position: 'absolute',
                        maxHeight: "100vh",
                        overflowY: "hidden"
                    }}
                >
                    <ExtraCardBackground />
                </Box>
                <Box sx={{ position: 'relative', zIndex: 1 }}>
                    <DialogTitle>
                        <img src={Logo} alt="Extraordinary" width={256} />
                    </DialogTitle>
                    <DialogContent>
                        <Typography variant="h3" width={"50%"} fontWeight={"bold"}>
                            Hold on while we set things up for you...
                        </Typography>
                        <CircularProgress thickness={6} size={128} sx={{ marginTop: "128px", marginLeft: "15%" }} />
                    </DialogContent>
                </Box>
            </Dialog>
            {children}
        </CheckoutLoadingContext.Provider>
    )
}

export { CheckoutLoadingContext, CheckoutLoadingProvider };